import { render } from "./contactData.vue?vue&type=template&id=33e90d14&ts=true"
import script from "./contactData.vue?vue&type=script&lang=ts"
export * from "./contactData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__